"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeAriaHiddenOnSiblings = void 0;
/**
 * @deprecated Use {@link useAriaHiddenOnSiblings} hook instead.
 * TODO remove this method in 5.0
 */
const changeAriaHiddenOnSiblings = (wrapper, state) => {
  if (!wrapper) return;
  const parent = wrapper.parentElement;
  if (!parent) return;
  Array.from(parent.children).filter(el => el.tagName !== 'SCRIPT' && el !== wrapper).forEach(el => {
    if (state && !el.attributes['aria-hidden']) {
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('data-stencil-aria-hidden-added', 'true');
    } else if (!state && el.hasAttribute('data-stencil-aria-hidden-added')) {
      el.removeAttribute('aria-hidden');
      el.removeAttribute('data-stencil-aria-hidden-added');
    }
  });
};
exports.changeAriaHiddenOnSiblings = changeAriaHiddenOnSiblings;